import { render } from "./About.vue?vue&type=template&id=6edac65a"
const script = {}

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__